import LandingV2 from 'detailsv2/LandingV2';
import { BurgerMenu } from 'detailsv2/LandingV2/Header/TopBar/BurgerMenu';
import s from 'detailsv2/LandingV2/index.module.css';

import AgentContactsModalContent from '../../../../shared/AgentContactsModalContent';
import { LANDING_PAGES_CONTAINER_ID } from '../../../../shared/LandingPage/components/Grid';
import Modal from '../../../../shared/Modal';
import RenderInDomNode from '../../../Admin/Page/common/RenderInStuff';
import { useLandingV2Preview } from '../../../shared/hooks';
import { RightActions } from './RightActions';
import { IItineraryLandingPageProps } from './types';

export const ItineraryLandingPagesV2 = ({ data }: IItineraryLandingPageProps) => {
  const { proposal, contactsModalHandler, isContactsModalOpen, consultantName, config } = useLandingV2Preview({
    data,
  });

  return (
    <>
      <LandingV2
        data={proposal}
        leftActions={<BurgerMenu />}
        rightActions={<RightActions contactsModalHandler={contactsModalHandler} />}
        config={config}
        readonly
      />
      {/* @ts-ignore This solution is implemented here due to the lack of I18N on the front-end and translations on the back-end. */}
      <RenderInDomNode id={LANDING_PAGES_CONTAINER_ID}>
        {/* @ts-ignore */}
        <Modal
          className="custom-agent-contacts-modal"
          isOpen={isContactsModalOpen}
          toClose={contactsModalHandler}
          contentClassName={s.contactsModal}
          size="md"
          noPadding
          noPortal
        >
          <AgentContactsModalContent
            phone={data.brandSettings?.contactPhone}
            whatsapp={data.brandSettings?.whatsapp!}
            mobile={data.brandSettings?.messagePhone!}
            email={data.brandSettings?.email}
            skype={data.brandSettings?.skype!}
            companyName={data.brandSettings?.companyName}
            consultantName={consultantName}
          />
        </Modal>
      </RenderInDomNode>
    </>
  );
};
